// The bag IS a Shopify cart. We persist only the cart ID; all line items,
// prices, subtotal, and the checkoutUrl are read back from Shopify so the drawer
// never shows stale data and Shopify owns the cart lifecycle (including clearing
// after a completed purchase). Thunks (redux-thunk) drive the Cart API.

import {
	cartFetch,
	cartCreate,
	cartLinesAdd,
	cartLinesUpdate,
	cartLinesRemove,
} from '../../catalog/storefront';

export const CART_SET = 'CART_SET';
export const BAG_OPEN = 'BAG_OPEN';
export const BAG_CLOSE = 'BAG_CLOSE';
export const BAG_LOADING = 'BAG_LOADING';

const STORAGE_KEY = 'nf-cart-id';

function loadCartId() {
	try {
		return localStorage.getItem(STORAGE_KEY);
	} catch (e) {
		return null;
	}
}
function saveCartId(id) {
	try {
		if (id) localStorage.setItem(STORAGE_KEY, id);
		else localStorage.removeItem(STORAGE_KEY);
	} catch (e) {
		/* storage blocked */
	}
}

export function cartSet(cart) {
	return { type: CART_SET, payload: cart };
}
export function setBagLoading(loading) {
	return { type: BAG_LOADING, payload: loading };
}
export function openBag() {
	return { type: BAG_OPEN };
}
export function closeBag() {
	return { type: BAG_CLOSE };
}

// Persist the id that came back (or clear it) and push the cart into state.
function applyCart(dispatch, cart) {
	saveCartId(cart ? cart.id : null);
	dispatch(cartSet(cart));
}

// On app load: rehydrate a stored cart. If Shopify no longer has it (expired or
// the checkout completed), forget it and start empty.
export function initCart() {
	return (dispatch) => {
		const id = loadCartId();
		if (!id) return;
		dispatch(setBagLoading(true));
		cartFetch(id)
			.then((cart) => applyCart(dispatch, cart))
			.catch(() => {})
			.then(() => dispatch(setBagLoading(false)));
	};
}

// Add a variant: create the cart on first add, otherwise add a line. If the
// stored cart has gone away, fall back to creating a fresh one.
export function addLine(variantId) {
	return (dispatch, getState) => {
		const { cartId } = getState().bag;
		const line = [{ merchandiseId: variantId, quantity: 1 }];
		dispatch(setBagLoading(true));
		dispatch(openBag());
		const op = cartId ? cartLinesAdd(cartId, line) : cartCreate(line);
		return op
			.then((cart) => {
				if (!cart && cartId) return cartCreate(line); // stored cart vanished
				return cart;
			})
			.then((cart) => applyCart(dispatch, cart))
			.catch(() => {})
			.then(() => dispatch(setBagLoading(false)));
	};
}

export function updateLine(lineId, qty) {
	return (dispatch, getState) => {
		const { cartId } = getState().bag;
		if (!cartId) return Promise.resolve();
		if (qty <= 0) return dispatch(removeLine(lineId));
		dispatch(setBagLoading(true));
		return cartLinesUpdate(cartId, [{ id: lineId, quantity: qty }])
			.then((cart) => applyCart(dispatch, cart))
			.catch(() => {})
			.then(() => dispatch(setBagLoading(false)));
	};
}

export function removeLine(lineId) {
	return (dispatch, getState) => {
		const { cartId } = getState().bag;
		if (!cartId) return Promise.resolve();
		dispatch(setBagLoading(true));
		return cartLinesRemove(cartId, [lineId])
			.then((cart) => applyCart(dispatch, cart))
			.catch(() => {})
			.then(() => dispatch(setBagLoading(false)));
	};
}
